export const AppRoutes = {
    root: '/',
    home: '/home',
    login: '/login',
    register: '/register',
    user: '/user/:userId',
    recoverPassword: '/recover-password',
    validateMailUser: '/validateMailUser/:token',
    validateDocument: '/validateDocument/:token',
    activateLikedinUser: '/activateLinkedinUser',
    admins: '/admins',
    posts: '/posts',
    singlePost: '/posts/:postId',
    communities: '/communities',
    community: '/communities/:communityId',
    pendingPosts: '/communities/:communityId/pendingPosts',
    news: '/news',
    messages: '/messages',
    pendingUser: '/pending-user',
    benefits: '/benefits',
    credential: '/credential',
    graduates: '/graduates',
    jobs: '/jobs',
    validateCredential: '/validate/credential',
    statistics: {
        main: '/statistics',
        tendencies: '/statistics/tendencies',
        successAreas: '/statistics/successAreas',
        improvementAreas: '/statistics/improvementAreas',
        academic: '/statistics/academic',
    },
}

export const ApiRoutes = {
    auth: {
        register: '',
        login: '/login',
        logout: '/logout',
        verifyExistence: '',
        registerPendingUser: '/pendingApprove',
    },
    users: {
        me: '/me',
        getAll: '',
        getAllGraduates: '/graduates',
        getById: '/:userId',
        update: '/update',
        activateUser: '/activateUser',
        validateDocumentIdentifier: '/validateDocumentIdentifier',
        validatePendingUser: '/validatePendingUser',
        getPendingUsers: '/pendingUsers',
        approve: '/approve/:userId',
        reject: '/reject/:userId',
        credential: '/credential/:userId/:university',
    },
    recoverPassword: {
        forgot: '/forgotPassword',
        check: '/checkResetPassword',
        activate: '/activateUser',
    },
    chat: {
        sendMessage: '',
        getChat: '/messages/:senderId/:recipientId',
        getAllChats: '/messages/:senderId',
    },
    posts: {
        published: '/published',
        pending: '/pending',
        rejected: '/rejected',
        likes: '/likes',
        comments: '/comments',
        approve: '/approve',
        reject: '/reject',
        newsAndEvents: '/newsAndEvents',
        events: '/events',
        benefits: '/benefits',
        myPending: '/pending/me',
        me: '/posts/me',
    },
    admin: {
        getAll: '',
        create: '',
        delete: '/:id',
    },
    communities: {
        getAll: '',
        getById: '/:id',
        getByUserId: '/users/:userId',
        getPublic: '/public',
        getPrivate: '/private',
        getMine: '/communities/me',
        getMyPendingRequests: '/communities/pending/me',
        create: '',
        getPosts: '/:id/posts',
        getPendingPosts: '/:id/posts/pending',
        createPost: '/:id/posts',
        edit: '/:id',
        requestJoin: '/:id/pendingMembers',
        addMember: '/:id/members',
        rejectRequest: '/:communityId/pendingMembers/:userId',
        removeMember: '/:communityId/members/:userId',
        addAdmin: '/:communityId/admins',
        removeAdmin: '/:communityId/admins/:userId',
        approvePost: '/:communityId/posts/:postId/approve',
        rejectPost: '/:communityId/posts/:postId/reject',
    },
    jobPosts: {
        getAll: '',
        me: '/me',
        create: '',
        candidates: '/candidates',
        expiration: '/expiration',
        recommended: '/recommended',
    },
    utilities: {
        validateCredential: '/validators/graduate/validateCredential/:token',
        createNewConfig: '/api/appConfig',
        getAppConfig: '/api/appConfig',
        getAbilities: '/api/abilities',
        getJobTitles: '/api/jobTitles',
        getCompanies: '/api/abilities/companies',
    },
    statistics: {
        hierarchicalPositions: '/hierarchicalPositions',
        daysToReachHierarchicalPosition: '/daysToReachHierarchicalPosition',
        workPlace: '/workPlace',
        freelancerOrEntrepreneurGraduates: '/freelancerOrEntrepreneurGraduates',
        commonRoles: '/commonRoles',
        commonAreas: '/commonAreas',
        commonCompanies: '/commonCompanies',
        commonAbilities: '/commonAbilities',
        commonWorkAbilities: '/commonWorkAbilities',
        commonAreasByHierarchy: '/mostCommonSectorsHierarchicalPosition',
        averageTimeInCompany: '/averageTimeInCompany',
        graduatesInCompanies: '/graduatesInCompanies',
        graduatesWithAptitudes: '/graduatesWithAptitudes',
        unemployedAbilities: '/commonAbilitiesUnemployedGraduates',
        graduatesInJobTitles: '/graduatesInJobTitles',
        usersWithoutWork: '/usersWithoutWork',
        daysToGraduate: '/daysToGraduate',
        averageToGetFirstJob: '/averageToGetFirstJob',
        graduatesWithPostGraduateDegrees: '/graduatesWithPostGraduateDegrees',
        topFirstJobCommonCompanies: '/topFirstJobCommonCompanies',
        topFirstJobCommonJobTitles: '/topFirstJobCommonJobTitles',
    },
}
